module.exports = __webpack_public_path__ + "static/media/IMG-20180924-WA0090.928f87a8.jpg";